import { css } from '@emotion/css';
import { colors, themeParser, useAppTheme } from '@/theme';

export const useJobStyles = () => {
  const theme = useAppTheme();

  return {
    root: css`
      .MuiDialog-paper {
        background: ${themeParser(colors.body.light, colors.body.dark, theme)};
        //width: 1500px;
        padding: 0 20px;
      }

      button {
        width: 100%;
        font-weight: 500;
        color: ${themeParser(colors.body.light, colors.black.default, theme)};
        margin: 0px 14px 25px 14px;
      }

      @media (max-width: 600px) {
        .MuiGrid-grid-sm-12 {
          width: 100%;
        }

        .MuiGrid-grid-sm-11 {
          width: 90%;
        }

        .MuiGrid-grid-sm-1 {
          width: 10%;
        }
      }

      .calculator {
        label {
          color: ${themeParser('rgba(0,0,0,0.87)', colors.primary, theme)};
          font-size: 15px;
          font-family: 'Poppins';
          font-weight: 500;
        }

        input {
          color: ${themeParser('rgba(0,0,0,0.87)', colors.primary, theme)};
        }

        button {
          margin: 15px 0px;

          svg {
            color: ${themeParser('rgba(0,0,0,0.87)', colors.primary, theme)};
          }
        }

        .MuiAutocomplete-root button {
          margin: 0px 14px 25px 14px;
          width: auto;
        }

        .delete {
          font-size: 20px;
          color: #F44336;
          cursor: pointer;
        }

        .add button {
          background-color: transparent !important;
          box-shadow: none;
          color: #b5b5b5 !important;
          border: 1px solid #e0e0e0;
          font-weight: 500;
          height: 32px;
          line-height: 32px;
        }

        .MuiInput-underline:hover:before,
        .MuiInput-underline:focus:before {
          border-bottom: 1px solid !important;
          color: ${colors.primary}
        }
      }
    }
    `,

    leftColumn: css`
      @media (min-width: 1600px) {
        flex-basis: 63.33333% !important;
        max-width: 63.33333% !important;
      }
    `,

    rightColumn: css`
      @media (min-width: 1600px) {
        flex-basis: 36.666667% !important;
        max-width: 36.666667% !important;
      }
    `,

    DialogTitle: css`
      background: #2196f3;
      padding: 8px !important;
      text-transform: uppercase !important;
      font-weight: 500 !important;
      letter-spacing: 1px;
      color: ${themeParser(colors.body.light, colors.body.dark, theme)};
      font-size: 1.15rem !important;
      text-align: center;
      font-family: 'Poppins', sans-serif !important;
    `,
    DialogContentRoot: css`
      ::-webkit-scrollbar {
        width: 4px;
      }

      /* Track */

      ::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      /* Handle */

      ::-webkit-scrollbar-thumb {
        background: #888;
      }

      /* Handle on hover */

      ::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    `,
    DialogContent: css`
      padding: 0px 0px 0px 0px;

      .MuiFormControl-root {
        margin-top: 25px;
      }

      .content-text {
        color: ${themeParser('auto', '#9E9E9E', theme)} !important;
      }

      .field-title {
        font-size: 1.15rem;
        color: ${themeParser('auto', '#939393', theme)} !important;
      }

      .searchable_input {
        overflow: hidden;

        label {
          color: ${themeParser(colors.body.dark, '#a0a0a0', theme)};
        }

        .MuiAutocomplete-paper {
          padding: 4px 10px;
          box-shadow:
            0px 5px 5px -3px rgb(0 0 0 / 20%),
            0px 8px 10px 1px rgb(0 0 0 / 14%),
            0px 3px 14px 2px rgb(0 0 0 / 12%);
          background: ${themeParser('#ffffff', '#2a2a2a', theme)};
          color: #2196f3;

          ul li {
            padding: 4px;
            cursor: pointer;
          }
        }

        .MuiFormHelperText-root.Mui-error {
          position: relative !important;
          bottom: 0px !important;
        }
      }

      .error {
        font-size: 12px;
        color: #d32f2f;
      }

      .install_search .MuiInput-root {
        color: ${themeParser(colors.body.dark, colors.primary, theme)};
      }

      .install_search .MuiInput-root:before {
        border-bottom: 1px solid ${themeParser(colors.primary, colors.primary, theme)};
      }

      .install_search .MuiInput-root button .MuiSvgIcon-fontSizeSmall {
        background: ${themeParser(colors.body.dark, colors.body.light, theme)};
      }

      .header_search_part {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;
      }

      .section_part {
        gap: 10px;
        margin-top: 40px;
      }

      span,
      div {
        color: ${themeParser('#000000de', '#cbcbcb', theme)};
      }
    `,
    titleCenter: css`
      text-align: center;
      color: ${themeParser(colors.body.dark, colors.primary, theme)};
    `,
    deleteIcon: css`
      line-height: 1;
      text-align: end;

      svg {
        color: ${colors.red.default};
        cursor: pointer;
      }
    `,
    bottomIcon: css`
      justify-content: space-between !important;
      border-top: 1px solid;
      margin: 10px 25px 0px 25px !important;
      padding: 25px 0px 0px 0px !important;

      button {
        width: 120px !important;
        margin: 0px 0px 25px 0px !important;
      }
    `,
    installActions: css`
      padding: 10px 24px !important;

      button {
        margin-bottom: 0px;
        margin: 0;
      }
    `,
    pdfView: css`
      .MuiDialog-paper {
        background: transparent;
        box-shadow: none;
      }

      object {
        align-items: center;
        width: 1200px;
        max-width: 100%;
        height: calc(78vh - 64px);
        margin-top: 2vh;
      }

      .MuiDialogActions-root {
        justify-content: center;
      }
    `,
    createJobsTitle: css`
      padding: 20px !important;
      text-transform: uppercase !important;
      font-weight: 500 !important;
      letter-spacing: 3px !important;
      color: ${themeParser(colors.body.dark, colors.primary, theme)};
      font-size: 1.2em !important;
      text-align: center;
      font-family: 'Poppins', sans-serif !important;
      border-bottom: 1px solid ${themeParser('#ddd', colors.primary, theme)};
    `,
    createJobsBottom: css`
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-top: 25px !important;
      padding-bottom: 25px !important;
      justify-content: space-between !important;

      button {
        width: auto !important;
        margin: 0 !important;
      }
    `,
  };
};
